import { OpenAPI } from '@api'
import isEqual from 'react-fast-compare'

import { LocalStorageKeys } from '@/consts/localStorage.ts'

import type { AccountState } from '../types'
import { deleteToken, persistToken } from '../utils/token'

/**
 * @param state - The old state that lives in the context
 * @param newState - The state that will be updating the old state
 */
export const accountReducer = (
  state: AccountState,
  newState: Partial<AccountState>,
): AccountState => {
  const potentialAccessToken = newState.accessToken

  if (potentialAccessToken) {
    const date = new Date()

    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()

    document.cookie = `auth._token.local=Bearer%20${potentialAccessToken}; ${expires}; path=/`
    OpenAPI.TOKEN = potentialAccessToken

    persistToken(LocalStorageKeys.AUTH_TOKEN, potentialAccessToken)
  } else if (potentialAccessToken === null) {
    OpenAPI.TOKEN = undefined

    deleteToken(LocalStorageKeys.AUTH_TOKEN)

    document.cookie =
      'auth._token.local=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  }

  // Prevent multiple rerender if the state didnt acutally change
  const nextState = { ...state, ...newState }

  if (isEqual(state, nextState)) {
    return state
  }

  return nextState
}
